import { Component, Injector, Input } from '@angular/core';
import { BaseModalComponent, EnumValues } from '@card-software/library';
import { Roll } from '../../../../models/production/roll';
import { EnumService } from '../../../../services/enum.service';

@Component({
  selector: 'app-roll-details',
  templateUrl: './roll-details.component.html',
  styleUrl: './roll-details.component.scss',
})
export class RollDetailsComponent extends BaseModalComponent<Roll | null> {
  @Input() roll: Roll | null = null;
  statuses: EnumValues;

  constructor(
    injector: Injector,
    private enumService: EnumService,
  ) {
    super(injector);
    this.statuses = this.enumService.getEnum('RollStatus', 'production').values;
  }
  onClose() {
    this.close({ action: 'close', data: null });
  }

  getStatus(status: number) {
    return this.statuses[status];
  }
}
